"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectDescriptionTheme = void 0;
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
var _colors = require("../../../birch/colors");
var BirchTheme = {
  backgroundColor: _colors.FullPalette.GREY_E500,
  contentColor: _colors.FullPalette.EVERGREEN_700,
  arrowBorderColor: 'transparent'
};
var injectDescriptionTheme = exports.injectDescriptionTheme = function injectDescriptionTheme(theme) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customRules = Object.keys(styles).map(function (k) {
    return "".concat(k, ": ").concat(styles[k], ";");
  });
  return (0, _styledComponents.createGlobalStyle)([".tippy-tooltip.information-theme{background-color:", ";box-shadow:0 1px 15px rgba(0,0,0,.2);", " padding:0;text-align:left;", "}.tippy-tooltip.information-theme .tippy-tooltip-content{padding:10px 15px;color:", ";}.tippy-tooltip.information-theme [x-circle]{background-color:white;}[x-placement^=\"bottom\"] .tippy-tooltip.information-theme > [x-arrow]{border-color:", " transparent;}[x-placement^=\"top\"] .tippy-tooltip.information-theme > [x-arrow]{border-color:", " transparent;}[x-placement^=\"left\"] .tippy-tooltip.information-theme > [x-arrow]{border-color:transparent ", ";}[x-placement^=\"right\"] .tippy-tooltip.information-theme > [x-arrow]{border-color:transparent ", ";}"], BirchTheme.backgroundColor, (0, _constants.fontWeight)('normal'), customRules.join('\n'), BirchTheme.contentColor, BirchTheme.arrowBorderColor, BirchTheme.arrowBorderColor, BirchTheme.arrowBorderColor, BirchTheme.arrowBorderColor);
};